import { useQuery } from '@tanstack/react-query'
import { Route, Routes, useLocation } from 'react-router-dom'

import { obtenerSalud } from './api/avisos'
import BarraPestanas from './componentes/BarraPestanas'
import SinConexion from './componentes/SinConexion'
import Ajustes from './pantallas/Ajustes'
import Biblioteca from './pantallas/Biblioteca'
import Buscar from './pantallas/Buscar'
import Descargas from './pantallas/Descargas'
import Explorar from './pantallas/Explorar'
import Finalizadas from './pantallas/Finalizadas'
import Fuente from './pantallas/Fuente'
import Lector from './pantallas/Lector'
import Manga from './pantallas/Manga'
import Viaje from './pantallas/Viaje'

// El icono es el nombre del PNG en /icons/pestanas. No se pinta con <img>
// sino como mascara CSS, para que tome el color de la pestana (ver estilos).
// La barra y su burbuja viven en `componentes/BarraPestanas`.
const PESTANAS = [
  { ruta: '/', icono: 'biblioteca', texto: 'Biblioteca' },
  { ruta: '/buscar', icono: 'buscar', texto: 'Buscar' },
  { ruta: '/descargas', icono: 'descargas', texto: 'Descargas' },
  { ruta: '/explorar', icono: 'explorar', texto: 'Explorar' },
  { ruta: '/ajustes', icono: 'ajustes', texto: 'Ajustes' },
]

export default function App() {
  // El lector ocupa la pantalla entera: ni barra de pestanas ni margenes
  const enLector = useLocation().pathname.startsWith('/leer/')

  /*
   * Punto rojo en Ajustes cuando el servidor tiene algo roto.
   *
   * Comparte clave de consulta con el panel de Ajustes, asi que las dos
   * pantallas se sirven de la misma peticion. Sin reintentos y sin ruido: si
   * no hay sesion o no hay red, simplemente no hay punto.
   */
  const { data: salud } = useQuery({
    queryKey: ['salud'],
    queryFn: obtenerSalud,
    retry: false,
    refetchInterval: 5 * 60 * 1000,
  })
  const algoRoto = salud?.estado === 'mal'

  if (enLector) {
    return (
      <Routes>
        <Route path="/leer/:id" element={<Lector />} />
      </Routes>
    )
  }

  return (
    <div className="app">
      <SinConexion />
      <main className="contenido">
        <Routes>
          <Route path="/" element={<Biblioteca />} />
          <Route path="/buscar" element={<Buscar />} />
          <Route path="/descargas" element={<Descargas />} />
          <Route path="/viaje" element={<Viaje />} />
          <Route path="/finalizadas" element={<Finalizadas />} />
          <Route path="/explorar" element={<Explorar />} />
          <Route path="/fuente/:id" element={<Fuente />} />
          <Route path="/manga/:id" element={<Manga />} />
          <Route path="/ajustes" element={<Ajustes />} />
        </Routes>
      </main>

      <BarraPestanas pestanas={PESTANAS} algoRoto={algoRoto} />
    </div>
  )
}
